import Globe from '@apps-common/react-globe';

import MapTool from '@apps-common/ui-maps/MapTool';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import {Box, Tooltip} from '@mui/material';

import {useTheme} from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import {trackEvent} from '@app/analytics';
import useMapViewParams from '@app/hooks/useMapViewParams';

const ZoomControls = ({minZoom, maxZoom, onZoom, additionalControls}) => {
  const theme = useTheme();
  const {center, zoom} = useMapViewParams();

  const onZoomIn = () => {
    trackEvent('Zoom Controls', {
      action: 'Zoom in',
    });
    onZoom(1);
  };

  const onZoomOut = () => {
    trackEvent('Zoom Controls', {
      action: 'Zoom out',
    });
    onZoom(-1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        maxWidth: 'inherit',
      }}
    >
      <Tooltip placement="left">
        <Box sx={{display: 'flex', flexDirection: 'column'}}>
          <MapTool
            icon={<AddIcon />}
            disabled={zoom >= maxZoom}
            tooltipTitle="Zoom in"
            onClick={onZoomIn}
            sx={{
              borderRadius: '4px 4px 0 0',
              boxShadow: 'none',
            }}
            value="zoom-in"
          />
          <MapTool
            icon={<RemoveIcon />}
            disabled={zoom <= minZoom}
            tooltipTitle="Zoom out"
            onClick={onZoomOut}
            sx={{
              borderRadius: 0,
              boxShadow: 'none',
            }}
            value="zoom-out"
          />
        </Box>
      </Tooltip>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 40,
          height: 60,
          bgcolor: 'background.paper',
        }}
        data-testid="globe"
      >
        <Globe
          center={center}
          landColor={theme.palette.common.white}
          markerColor={theme.palette.primary.main}
          oceanColor="#393a3f"
        />
      </Box>
      {additionalControls}
    </Box>
  );
};

ZoomControls.propTypes = {
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  additionalControls: PropTypes.node,
  onZoom: PropTypes.func,
};

export default ZoomControls;
